module.exports = __webpack_public_path__ + "img/ys.291cdc8f.png";